import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WMultiPageGuidesCCD: IClientComponentDefinition = {
  name: 'WMultiPageGuides',
  load: () => import(/* webpackChunkName: 'WMultiPageGuides' */ '.'),
}
